import { render, staticRenderFns } from "./ReviewInventory.vue?vue&type=template&id=576e9fd9&scoped=true&"
import script from "./ReviewInventory.vue?vue&type=script&lang=js&"
export * from "./ReviewInventory.vue?vue&type=script&lang=js&"
import style0 from "./ReviewInventory.vue?vue&type=style&index=0&id=576e9fd9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576e9fd9",
  null
  
)

export default component.exports